import {createAsyncThunk} from '@reduxjs/toolkit';
import api, {CustomAxiosConfig} from 'services/axios';

import {
  ConfirmCouponPreorderInput,
  ConfirmCouponPreorderResponse,
  CreateCouponPreorderInput,
  CreateCouponPreorderResponse,
  GetCouponDetailsInput,
  GetCouponDetailsResponse,
  GetCouponHistoryListInput,
  GetCouponHistoryListResponse,
  GetCouponTemplateListInput,
  GetCouponTemplateListResponse,
  PauseCouponInput,
  PauseCouponResponse,
  RemoveCouponInput,
  RemoveCouponResponse
} from './types';

export const getCouponHistoryList = createAsyncThunk<
  GetCouponHistoryListResponse,
  GetCouponHistoryListInput
>('getCouponHistoryList', async (params, thunkApi) => {
  try {
    const response = await api.get(`/dasht/coupon`, {
      params,
      goBaseUrl: true
    } as CustomAxiosConfig);
    return thunkApi.fulfillWithValue(response.data);
  } catch (error: any) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getCouponDetails = createAsyncThunk<GetCouponDetailsResponse, GetCouponDetailsInput>(
  'getCouponDetails',
  async (input, thunkApi) => {
    const params = {
      vendor_id: input.vendor_id
    };

    try {
      const response = await api.get(`/dasht/coupon/${input.coupon_id}`, {
        params,
        goBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (error: any) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getCouponTemplateList = createAsyncThunk<
  GetCouponTemplateListResponse,
  GetCouponTemplateListInput
>('getCouponTemplateList', async (input, thunkApi) => {
  try {
    const response = await api.get(`/dasht/coupon/templates`, {
      params: input,
      goBaseUrl: true
    } as CustomAxiosConfig);
    return thunkApi.fulfillWithValue(response.data);
  } catch (error: any) {
    return thunkApi.rejectWithValue(error);
  }
});

export const removeCoupon = createAsyncThunk<RemoveCouponResponse, RemoveCouponInput>(
  'removeCoupon',
  async (input, thunkApi) => {
    const params = {
      vendor_id: input.vendor_id
    };

    try {
      const response = await api.delete(`/dasht/coupon/${input.coupon_id}`, {
        params,
        goBaseUrl: true
      } as CustomAxiosConfig);
      return thunkApi.fulfillWithValue(response.data);
    } catch (error: any) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const pauseCoupon = createAsyncThunk<PauseCouponResponse, PauseCouponInput>(
  'pauseCoupon',
  async (input, thunkApi) => {
    try {
      const response = await api.put(
        `/dasht/coupon/${input.coupon_id}/pause?vendor_id=${input.vendor_id}`,
        {},
        {
          goBaseUrl: true
        } as CustomAxiosConfig
      );
      // sleep 5 seconds. it is backend requirement
      await new Promise((resolve) => {
        setTimeout(() => {
          resolve(true);
        }, 5000);
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (error: any) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const createCouponPreorder = createAsyncThunk<
  CreateCouponPreorderResponse,
  CreateCouponPreorderInput
>('createCouponPreorder', async (params, thunkApi) => {
  try {
    const body = {
      template_id: params.template_id,
      start_time: params.start_time,
      end_time: params.end_time
    };

    const response = await api.post(`/dasht/coupon/preorder?vendor_id=${params.vendor_id}`, body, {
      goBaseUrl: true
    } as CustomAxiosConfig);
    return thunkApi.fulfillWithValue(response.data);
  } catch (error: any) {
    return thunkApi.rejectWithValue(error);
  }
});

export const confirmCouponPreorder = createAsyncThunk<
  ConfirmCouponPreorderResponse,
  ConfirmCouponPreorderInput
>('confirmCouponPreorder', async (params, thunkApi) => {
  try {
    const body = {
      code: params.code
    };

    const response = await api.put(`/dasht/coupon/preorder?vendor_id=${params.vendor_id}`, body, {
      goBaseUrl: true
    } as CustomAxiosConfig);
    return thunkApi.fulfillWithValue(response.data);
  } catch (error: any) {
    return thunkApi.rejectWithValue(error);
  }
});
